export default {
  modalTrigger: {
    id: 'product_highlighted_picker_modal_trigger',
    defaultMessage: 'Learn more',
  },
  title: {
    id: 'product_highlighted_picker_title',
    defaultMessage: 'Our goodest finds',
  },
}
